<template>
    <div class="">

        <Banner :background="(item.image) ? item.image.url : ''"
            :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.en.title : item.ar.title : ''">
        </Banner>

        <section id="Services" class="services-list pt-100 pb-70">
            <div class="container">

                <div v-if="dataLoading" class="row">
                    <div class="col-6 col-lg-3" v-for="(item, idx) in 8" :key="idx">
                        <div class="feature-item two webkit-animation webkit-300-220"></div>
                    </div>
                </div>

                <div v-if="!dataLoading" class="row">
                    <div class="col-md-6 col-lg-3 col-sm-12" v-for="(item, idx) in services" :key="idx">
                        <div class="feature-item two">
                            <img v-if="item.image" :src="item.image.url"
                                style="width:140px;height: 140px;border-radius: 50%">
                            <h3>
                                <a href="javascript:;">
                                    {{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}
                                </a>
                            </h3>
                        </div>
                    </div>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'List',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data() {
        return {
            //
            item: '',
            refs: 'pages/ourservices',
            pgLoading: true,
            dataLoading: true,
            services: [],
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
        this.fetchService();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: window.appID
                }
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.item = res.data.data;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

        fetchService() {
            this.dataLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/services',
                method: 'GET',
                data: {}
            }
            this.axios(options)
                .then(res => {
                    this.dataLoading = false;
                    this.services = res.data.data.rows;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
